import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgCashDrawer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.5v6H2v-6m20 0l-1.5-4h-1.161m2.661 4H2m0 0l1.5-4h1.474M9 16.5h6m1.105-8.924l.241-.065M7.412 9.905l.241-.065m-1.416 3.438a1.991 1.991 0 01-.481-.859L4.721 8.556a2 2 0 011.414-2.45l9.66-2.588a2 2 0 012.449 1.414l1.035 3.864a2 2 0 01-1.414 2.45l-8.186 2.193m4.253-5.281a2 2 0 11-3.864 1.035 2 2 0 013.864-1.035z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export { SvgCashDrawer as ReactComponent };
